import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { useEffect } from "react";
import { Route, Switch, useLocation } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import NavigationHistoryTracker from "./components/navigation/NavigationHistoryTracker/NavigationHistoryTracker";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AppFooter } from "./components/navigation/AppFooter/AppFooter";
import { TaskEditSheetProvider } from "./components/tasks/sheets/TaskEditSheet/TaskEditSheetHost";
import Calendar from "./pages/Calendar";
import Home from "./pages/Home";
import Settings, {
  SettingsAccount,
  SettingsAlerts,
  SettingsLists,
  SettingsCalendar,
  SettingsInterface,
} from "./pages/Settings";
import ListEditor from "./pages/ListEditor";
import CategoryEditor from "./pages/CategoryEditor";
import AddList from "./pages/AddList";
import ListToDay from "./pages/ListToDay";
import TaskDetail from "./pages/TaskDetail";
import TaskColors from "./pages/TaskColors";
import TaskLog from "./pages/TaskLog";
import TaskResults from "./pages/TaskResults";
import Reports from "./pages/Reports";
import Inbox from "./pages/Inbox";
import Lists from "./pages/Lists";
import ListDetail from "./pages/ListDetail";
import { PrivacyPolicy, TermsOfService } from "./pages/Legal";
import { NotesComingSoon, SearchComingSoon } from "./pages/ComingSoon";

function Router() {
  return (
    <Switch>
      <Route path="/privacy" component={PrivacyPolicy} />
      <Route path="/terms" component={TermsOfService} />
      <Route path="/" component={Home} />
      <Route path="/notes" component={NotesComingSoon} />
      <Route path="/search" component={SearchComingSoon} />
      <Route path="/tasks/schedule" component={Calendar} />
      <Route path="/tasks/lists" component={Lists} />
      <Route path="/tasks/insights" component={Reports} />
      <Route path="/tasks/settings" component={SettingsLists} />
      <Route path="/calendar" component={Calendar} />
      <Route path="/settings/lists/:id" component={ListEditor} />
      <Route path="/settings/categories/:id" component={CategoryEditor} />
      <Route path="/settings/lists" component={SettingsLists} />
      <Route path="/settings/alerts" component={SettingsAlerts} />
      <Route path="/settings/calendar" component={SettingsCalendar} />
      <Route path="/settings/interface" component={SettingsInterface} />
      <Route path="/settings/account" component={SettingsAccount} />
      <Route path="/settings" component={Settings} />
      <Route path="/day/:date/add/:listId" component={ListToDay} />
      <Route path="/day/:date/add" component={AddList} />
      <Route path="/task/:id/display" component={TaskColors} />
      <Route path="/task/:id/results" component={TaskResults} />
      <Route path="/task/:id/log" component={TaskLog} />
      <Route path="/task/:id" component={TaskDetail} />
      <Route path="/lists/:category/:slug" component={ListDetail} />
      <Route path="/lists/:slug" component={ListDetail} />
      <Route path="/lists" component={Lists} />
      <Route path="/inbox" component={Inbox} />
      <Route path="/reports" component={Reports} />
      <Route path="/404" component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <TooltipProvider>
          <TaskEditSheetProvider>
            <NavigationHistoryTracker />
            <div className="app-frame">
              <div className="app-route">
                <Router />
              </div>
              <AppFooter />
            </div>
          </TaskEditSheetProvider>
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
